
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { send } from "../../app/appSlice"
import { AppThunkApi, RootState } from "../../app/store";
import { Factory } from "../../models/factory";
import { firstPage, Page } from "../../models/page";
import { getFactoryDetail, getFactoryPage, FactoryParams, getIncludeSystem, getAreaList, getCityEntranceSystem } from "../../services/factory";
interface factoryState {
    factoryList: Page<Factory>,
    factoryDetail: Factory,
    areaList: [],
    link: ""
}

const initialState: factoryState = {
    factoryList: firstPage(),
    factoryDetail: {},
    areaList: [],
    link: ""
};

// 分页
export const getFactoryListAsync = createAsyncThunk<
    Page<Factory>,
    FactoryParams,
    AppThunkApi
>("FactoryList/page", async (body, api) => {
    return send(getFactoryPage(body), api)
})

// 详情
export const getFactoryDetailAsync = createAsyncThunk<
    void,
    number,
    AppThunkApi
>("FactoryDetail/detail", async (params, api) => {
    return send(getFactoryDetail(params), api)
})

//进入系统
export const getIncludeSystemAsync = createAsyncThunk<
    void,
    number,
    AppThunkApi
>("IncludeSystem/include", async (params, api) => {
    return send(getIncludeSystem(params), api)
})

// 首页地图点击跳转
export const getEntranceAsync = createAsyncThunk<
    void,
    string,
    AppThunkApi
>("EntranceInclude/Entrance", async (params, api) => {
    return send(getCityEntranceSystem(params), api)
})


//地区
export const getAreaListAysc = createAsyncThunk<
    any,
    void,
    AppThunkApi
>("AreaList/list", async (_, api) => {
    return send(getAreaList(), api)
})

export const FactoryListSlice = createSlice({
    name: "FactoryListStation",
    initialState,
    reducers: {
        setFactoryList(state, action) {
            state.factoryList = action.payload;
        },
        setExceptionDetail(state, action) {
            state.factoryDetail = action.payload;
        },
        setAreaList(state,action){
            state.areaList = action.payload
        },
    },
    extraReducers: (builder) => {
        builder.addCase(getFactoryListAsync.fulfilled, (state, action: any) => {
            state.factoryList = action.payload;
        })
        builder.addCase(getFactoryDetailAsync.fulfilled, (state, action: any) => {
            state.factoryDetail = action.payload;
        })
        builder.addCase(getAreaListAysc.fulfilled, (state, action: any) => {
            state.areaList = action.payload;
        })
    }
});

export const { setFactoryList, setExceptionDetail } =
    FactoryListSlice.actions;

export const selectFactoryList = (state: RootState) => state.factory.factoryList

export const selectFactoryDetail = (state: RootState) => state.factory.factoryDetail

export const selectAreaList = (state: RootState) => state.factory.areaList

export default FactoryListSlice.reducer;